import { apiList, apiGet, apiCreate, apiUpdate, apiDelete } from './apiClient';

export const getUnits = async (params?: any) => apiList('units', params);
export const getUnitById = async (id: number | string) => apiGet('units', id);
export const createUnit = async (data: any) => apiCreate('units', data);
export const updateUnit = async (id: number | string, data: any) => apiUpdate('units', id, data);
export const deleteUnit = async (id: number | string) => apiDelete('units', id);
